import {  Navigate,  useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import moment from 'moment';

const PrivateRoute = ({children }:any) => {

  let { pathname }: any = useLocation();
  let type: any = pathname.split('/').pop()
  const userDetailsCookies:any = Cookies.get('details') 
  const details:any = userDetailsCookies ? JSON.parse(userDetailsCookies) : {'isLoggedIn' : false}
  const userIsLoggedIn:any = details['isLoggedIn'];
  const currentDate:any = moment(new Date()).format("YYYY-MM-DD")
  const userExpiry:any = moment(new Date(details['expiry'])).format("YYYY-MM-DD")


  let cookiesCodesArray:any = Cookies.get('codesArray');
  let userPrivilegesArray:any =Cookies.get('codesArray') ? JSON.parse(cookiesCodesArray) : []
  let formatteduserPrivilegesArray:any = [] ;
  userPrivilegesArray.filter((item:any) => { 
    formatteduserPrivilegesArray.push(item.slice(0,3)==='EBM'?item.slice(0,3):(item).slice(1,3)+String(item).charAt(item.length - 1))
  })

  const historicalSublinkPrivilegeArchitecture: any = Object.freeze({
    'commodityFutIntraday': 'CFI',
    'equityMultiday': 'ESM',
    'equityN50BANK':'EBM',
    'forexFutIntraday': 'FFI',
    'forexFutMultiday': 'FFM',
    'forexOptIntraday': 'FOI',
    'stockPairIntraday': 'PTI',
    'stockFutIntraday': 'SFI',
    'stockIndexFutIntraday': 'IFI',
    'stockindexOptIntraday': 'IOI',
    'stockOptIntraday': 'SOI',
    'backoffice': 'ACE', 
    'portfolio': 'ORO'
  })

  return (
    (userIsLoggedIn  && (currentDate <= userExpiry))? (['live', 'news', 'subscription'].includes(type) ? children : formatteduserPrivilegesArray.includes(historicalSublinkPrivilegeArchitecture[type])) ?  children : <Navigate to="/live"/> : <Navigate to="/" />
  );
};

export default PrivateRoute;














